<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" style="height: 100vh">
        <v-card class="modal-container text-center mb-5" style="width: 90vw">
          <div>
            <v-dialog v-model="loadingTicket" persistent transition="none" width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Loading Ticket
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-card-text class="headline font-weight-bold">Multi Ticket Redemption
            </v-card-text>
            <v-alert dense outlined type="error" class="font-weight-bold">
              Tickets, when scanned are Immediately recorded as cashed in the
              Terminal Database, <br />
              <strong>THIS ACTION CANNOT BE REVERTED!</strong>
            </v-alert>
            <v-card-subtitle class="mt-n6 font-weight-bold">Total Tickets Scanned:
              {{ scannedTickets.length }}</v-card-subtitle>
            <v-card-subtitle class="mt-n6 green--text font-weight-bold">Win Tickets: {{ winTickets.length
            }}</v-card-subtitle>
            <div style="clear: both"></div>
            <v-card-text v-if="error">
              {{ error }}
            </v-card-text>
          </div>
          <v-card elevation="0" class="text-center">
            <div class="ma-2 float-right">
              <v-btn elevation="0" class="float-left mb-1 mr-1" width="110px" color="grey darken-1" small dark
                @click="scrollTop"><v-icon>mdi-chevron-up</v-icon></v-btn>
              <v-btn elevation="0" class="float-right mb-1" width="110px" color="grey darken-1" small dark
                @click="scrollDown"><v-icon>mdi-chevron-down</v-icon></v-btn>
            </div>
            <div style="clear: both"></div>

            <v-simple-table dense :fixed-header="true" height="40vh" class="transactionTable font-weight-bold">
              <thead>
                <tr class="">
                  <th class="text-left">Ticket ID</th>
                  <th class="text-left">Race</th>
                  <th class="text-left">Bet Type</th>
                  <th class="text-left">Status</th>
                  <th class="text-right">Amount $</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t, index) in scannedTickets" :key="index">
                  <td class="text-left">{{ t.ticketId || "-" }}</td>
                  <td class="text-left">
                    {{ t.isVoucher? 'NaN': showTicketDetails(t.detail) }}
                  </td>
                  <td class="text-left">
                    {{ t.isVoucher? 'Voucher': betype(t.detail.betType) || "-" }}
                  </td>
                  <td :class="
                    t.balance && (t.detail && t.detail.status == 'paid' || t.isVoucher)
                      ? 'green--text text-left'
                      : 'grey--text text-left'
                  ">
                    {{ formatTicketStatus(t) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    ${{ t.balance ? t.balance.toFixed(2) : '0.00' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
          <v-divider inset></v-divider>
          <v-card-text class="headline text-right font-weight-bold">
            Amount Cashed: ${{ totalPayoutAmt }}
          </v-card-text>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn elevation="0" v-if="ejectOn" class="mr-2 white--text" color="blue" @click="eject()">Eject</v-btn>
            <v-btn elevation="0" x-large color="success overline" dark @click="$emit('onManualScan')">
              <v-icon class="mr-2">mdi-barcode-scan</v-icon>Manual <br />Ticket
              <br />Punch
            </v-btn>

            <v-btn elevation="0" class="ml-2" x-large style="font-size: 12px" color="error"
              @click="closeMultiRedemption()">
              <span>Exit<br />Multi-Redemption<br />Mode</span>
            </v-btn>
            <!--<v-spacer></v-spacer>
              <v-btn elevation="0"
                x-large
                color="success"
                :disabled="!totalPayoutAmt"
                @click="payOutScannedTickets"
              >
                 <span class="display-1">PAYOUT: ${{totalPayoutAmt}}</span> 
              </v-btn>-->
          </div>
        </v-card>
      </div>
      <ConfirmDialog ref="confirm"></ConfirmDialog>
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { getBetTypeName, getTicketStatusName } from "../common/methods";
import ConfirmDialog from "./common/ConfirmDialog.vue";
import { updateCustomerDisplayScannedTickets } from "../common/customerDisplay";

export default {
  data() {
    return {
      error: ""
    };
  },
  props: {
    loadingTicket: Boolean
  },

  computed: {
    ...mapGetters(["getScannedTickets", "getVenueName"]),
    scannedTickets() {
      return this.$store.getters.getScannedTickets;
    },
    totalPayoutAmt() {
      let totalAmt = 0;
      this.winTickets.forEach((t) => {
        totalAmt += t.balance;
      });
      this.scratchedTickets.forEach((t) => {
        totalAmt += t.balance;
      });
      this.vouchers.forEach(t=> totalAmt += t.balance)

      return totalAmt.toFixed(2);
    },
    winTickets() {
      return this.getScannedTickets.filter(
        (t) => t.detail?.status === "paid" && t.balance
      );
    },
    scratchedTickets() {
      return this.getScannedTickets.filter(t => t.detail?.status === 'cancelled' && t.balance)
    },
    vouchers(){
      return this.getScannedTickets.filter(t=>t.isVoucher)
    },
    ejectOn() {
      if (window.rt) return true
      return false
    }
  },
  methods: {
    ...mapActions(["updateScannedTickets", "updateMultiRedemptionMode"]),
    eject() {
      if (window.rt) {
        window.rt.eject();
      } else {
        console.log('not RT')
      }
    },
    betype(v) {
      return getBetTypeName(v, this.getVenueName);
    },
    showTicketDetails(v) {
      return `${v?.raceName} R${v?.raceNumber} - ${v.selections[0]?.number}`
    },
    scrollTop() {
      let content = document.querySelector(".v-data-table__wrapper");
      content.scrollTop -= 50;
    },
    scrollDown() {
      let content = document.querySelector(".v-data-table__wrapper");
      content.scrollTop += 50;
    },
    ticketStatusName(v, ticket) {
      return getTicketStatusName(v, ticket, this.getVenueName);
    },
    payOutScannedTickets() { },
    async closeMultiRedemption() {
      if (
        await this.$refs.confirm.open(
          `Exit Multi Ticket Redemption`,
          `You are exiting multi ticket redemption mode, please confirm total amount ($${this.totalPayoutAmt}) has been cashed before exit.`
        )
      ) {
        this.updateMultiRedemptionMode(false);
        // clear customer display when exit multi redemption mode
        updateCustomerDisplayScannedTickets([]);
      }
    },
    formatTicketStatus(ticket) {
      if (ticket.isVoucher){
        return ticket.balance ? 'Redeemable':'Previously Redeemed'
      }
      if (ticket.detail.status === 'cancelled') {
        return ticket.balance ? "Scratched" : "Cancelled";
      }
      return getTicketStatusName(ticket.detail?.status, ticket, this.getVenueName)
    },
  },
  components: {
    ConfirmDialog,
  },
};
</script>
